import apiClient from '../axios.js';

export const smartMarketingService = {
  getRecommendations: async () => {
    return apiClient.get('/marketing/smart-marketing/recommendations');
  },

  getRecommendationDetail: async (scenario) => {
    return apiClient.get(`/marketing/smart-marketing/recommendations/${encodeURIComponent(scenario)}`);
  },

  estimateCost: async (payload) => {
    return apiClient.post('/marketing/smart-marketing/estimate-cost', payload);
  }
};
